import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";

import { Button, Confirm } from "react-admin";

import { EditIcon, ShowIcon } from "../../../../components/common/iconography";
import { deepRedirect } from "../../../../utils/utils";
import { isUnmanagedLocation } from "../../../../utils/locationUtils";

const useStyles = makeStyles((theme) => ({
  alignRight: {
    textAlign: "right",
  },
}));

export const OpenInventoryItemButton = ({
  form,
  record,
  inventory,
  backPath,
  isDeleting,
  ...props
}) => {
  const classes = useStyles();
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const location = record?.location;
  const isEditable = isUnmanagedLocation(location);

  const handleOpen = () => {
    debugger;
    const formState = form?.getState();
    if (formState?.dirty) setOpen(true);
    else handleConfirm();
  };

  const handleDialogClose = () => setOpen(false);
  const handleConfirm = () => {
    debugger;
    if (isEditable) {
      deepRedirect(history, `/inventoryItems/${record.id}`, backPath, {
        inventory: inventory,
      });
    } else {
      deepRedirect(history, `/inventoryItems/${record.id}/show`, backPath, {
        inventory: inventory,
      });
    }
  };

  if (!record) return null;
  return (
    <div className={classes.alignRight}>
      {isEditable ? (
        <Button
          label="EDIT"
          size="small"
          color="primary"
          onClick={handleOpen}
          disabled={isDeleting}
        >
          <EditIcon />
        </Button>
      ) : (
        <Button
          label="SHOW"
          size="small"
          color="primary"
          onClick={handleOpen}
          disabled={isDeleting}
        >
          <ShowIcon />
        </Button>
      )}
      <Confirm
        isOpen={open}
        title="Save Confirmation"
        content="You have un-saved Inventory changes. If you continue, all changes will be lost. Proceed?"
        onConfirm={handleConfirm}
        onClose={handleDialogClose}
      />
    </div>
  );
};
